@let panelDirs = panels();

<div
  ngpTabset
  class="w-full"
  ngpTabsetOrientation="horizontal"
  [ngpTabsetValue]="value()"
  (ngpTabsetValueChange)="onValueChange($event)"
>
  <div
    ngpTabList
    [class]="stepTabListClass"
  >
    @if (rect(); as rect) {
      <span
        aria-hidden="true"
        [class]="slidingBarClass()"
        [style.left.px]="rect.left"
        [style.width.px]="rect.width"
      ></span>
    }

    @for (opt of options(); track opt.value; let index = $index; let isLast = $last) {
      @let status = statusOf(opt);
      @let editDef = value() === opt.value ? editDescriptionDef() : undefined;

      <div
        #item
        class="flex shrink-0 items-center gap-2"
      >
        <button
          type="button"
          ngpTabButton
          [ngpTabButtonValue]="opt.value"
          [ngpTabButtonDisabled]="opt.disabled"
          [class]="stepTabButtonClass"
          [class.pointer-events-none]="!clickable()"
        >
          <span
            aria-hidden="true"
            [class]="stepTabMarkerClass({ status })"
          >
            @switch (status) {
              @case ('success') {
                <ks-icon
                  name="circle-check"
                  size="lg"
                  decorative
                ></ks-icon>
              }
              @case ('error') {
                <ks-icon
                  name="triangle-alert"
                  size="lg"
                  decorative
                ></ks-icon>
              }
              @default {
                {{ index + 1 }}
              }
            }
          </span>

          <span class="flex min-w-0 flex-col">
            <span [class]="stepTabLabelClass">{{ opt.label | ksTranslate }}</span>

            @if (opt.description && !editDef) {
              <span [class]="stepTabDescriptionClass">
                {{ opt.description | ksTranslate }}
              </span>
            }
          </span>
        </button>

        @if (editDef) {
          <ng-container [ngTemplateOutlet]="editDef.template" />
        }
      </div>

      @if (!isLast) {
        <span
          aria-hidden="true"
          [class]="stepTabConnectorClass"
        ></span>
      }
    }
  </div>

  @for (panel of panelDirs; track panel.value()) {
    <div
      ngpTabPanel
      [ngpTabPanelValue]="panel.value()"
      [class]="stepTabPanelClass"
    >
      <ng-container [ngTemplateOutlet]="panel.template"></ng-container>
    </div>
  }
</div>
